// extracted by mini-css-extract-plugin
module.exports = {"container":"HomeUser_container__3PRNG","title":"HomeUser_title__BzQ39","img":"HomeUser_img__1r48U"};